class ApiLinks {
    _home_ws = '/ws/v2';
    _home = '/api/v2';
    _admin = '/admin';
    _eventsHome = this._home + '/events';
    _notificationsHome = this._home + '/notifications';
    _notificationSubscriptionsHome = this._home + '/notifications/subscribe';
    _statisticsHome = this._home + '/statistics';
    _devicesHome = this._home + '/devices';
    _reportsHome = this._home + '/reports';
    _eventTypesHome = this._home + '/eventTypes';
    _companyLoggerHome = this._home + '/companyLoggers';
    _companyHome = this._home + '/companies';
    _publicDashboardHome = this._home + '/public/dashboard';
    _salesHome = this._home + '/sales';
    _departmentsHome = this._home + '/departments';
    _profileHome = this._home + '/profile/me';
    _loggersHome = this._home + '/loggers';
    _adminUserHome = this._home + this._admin + '/users';
    _adminLoggersHome = this._home + this._admin + '/loggers';
    _resellerHome = this._home + this._admin + '/resellers';
    _adminCompanyLoggersHome = this._home + this._admin + '/companyLoggers';
    _adminNotificationsHome = this._home + this._admin + '/notifications';
    _adminDepartmentsHome = this._home + this._admin + '/departments';
    _adminGatewaysHome = this._home + this._admin + '/gateways';
    _adminAcceptanceProtocolsHome = this._home + this._admin + '/acceptanceProtocols';
    _assetsHome = this._home + this._admin + '/assets';
    _adminSalesHome = this._home + this._admin + '/sales';
    _adminTiersHome = this._home + this._admin + '/tiers';
    _adminCompanyTiersHome = this._home + this._admin + '/companies';
    _adminSystemHome = this._home + this._admin + '/system';
    _adminDevicesHome = this._home + this._admin + '/devices';
    Home = this._home;
    AdminHome = this._home + this._admin;
    Auth = {
        Login: '/auth/login',
        Logout: '/auth/logout',
        KeyCheck: '/auth/keyCheck',
        TokenCheck: '/auth/tokencheck',
        VerifyResend: '/auth/resend',
        Verify: '/auth/verify',
        Register: '/auth/register',
        PasswordForgot: '/auth/password/forgot',
        PasswordChange: '/auth/password/change'
    };
    Profile = {
        Home: this._profileHome,
        Settings: this._profileHome + '/settings',
        Me: this._profileHome,
        Phone: this._profileHome + '/phone',
        SendCode: this._profileHome + '/phone/sendCode',
        VerifyNumber: this._profileHome + '/phone/verify',
        ChangePassword: '/changePassword'
    };
    Users = {
        AdminHome: this._adminUserHome,
        Sessions: this._profileHome + '/sessions',
        Keys: {
            Disable: '/disable',
            Enable: '/enable',
            Role: '/role',
            Users: '/users',
            Owner: '/ownership',
            Settings: '/settings',
            Notifications: '/notifications',
            PhoneNumber: '/phoneNumber',
            SendCode: '/phoneNumber/sendCode',
            VerifyNumber: '/phoneNumber/verify',
            Departments: '/departments',
            Presets: '/settings/presets',
            PreRegister: '/preregister',
            RequestVerification: '/requestVerification',
            MarkContactPerson: '/mark-contact-person',
            UnmarkContactPerson: '/unmark-contact-person',
            ContactInfo: '/contact-info',
            Photo: '/photo'
        }
    };
    Gateways = {
        Home: this._devicesHome,
        AdminHome: this._adminGatewaysHome,
        Registration: this._devicesHome + '/register',
        DeviceExists: this._devicesHome + '/exists',
        Firmwares: this._adminGatewaysHome + '/firmwares',
        Keys: {
            Gateways: '/gateways',
            Scan: '/scan',
            Config: '/config',
            Update: '/update',
            Activate: '/activate',
            ImportCsv: '/import/csv',
            Instances: '/instances',
            Credentials: '/credentials',
            Revoke: '/revoke',
            Revert: '/forceRevert',
            Return: '/return',
            Publish: '/publish',
            Register: '/register',
            Replace: '/replace',
            firmwares: '/firmwares',
            commands: '/commands',
            Updates: '/updates',
            SelfUpdate: '/self-update',
            TestSiren: '/testSiren',
            LoggersConfigure: '/loggers/configure',
            LoggersInRange: '/loggers/inRange',
            ReadData: '/readData',
            HawkBitStatus: '/hawkbit/status',
            Photo: '/photo'
        }
    };
    Assets = {
        AdminHome: this._assetsHome,
        Keys: {
            Devices: '/devices',
            Photo: '/photo'
        }
    };
    Devices = {
        Home: this._devicesHome,
        Registration: this._devicesHome + '/register'
    };
    DeviceGroups = this._home + '/deviceGroups';
    Configs = this._home + '/configs';
    LoggerGroups = this._home + '/loggerGroups';
    Events = {
        Home: this._eventsHome,
        Graph: this._eventsHome + '/graph',
        ByLogger: this._eventsHome + '/byLogger',
        ByDevice: this._eventsHome + '/byDevice',
        ByLoggerGroup: this._eventsHome + '/byLoggerGroup',
        Last: this._eventsHome + '/last',
        Keys: {
            Last: '/data/last',
            EventTypes: '/data/types',
            Units: '/data/units',
            Chart: '/data/chart',
            Outage: '/data/outage'
        }
    };
    Sharelink = {
        dashboards: '/data/dashboards'
    };
    Loggers = {
        Home: this._loggersHome,
        AdminHome: this._adminLoggersHome,
        Keys: {
            Publish: '/publish',
            VerificationKey: '/verificationKey',
            Loggers: '/loggers',
            Configs: '/configs',
            SourceChanges: '/assignments',
            ImportCsv: '/import/csv',
            Photo: '/photo'
        }
    };
    SmartCitySensors = {
        Home: this._home,
        Keys: {
            Public: '/public',
            Sensors: '/smartcity/sensors'
        }
    };
    Company = {
        Home: this._companyHome,
        Current: this._companyHome + '/current',
        Invite: this._companyHome + '/invite',
        Settings: this._companyHome + '/settings'
    };
    Reseller = {
        Home: this._resellerHome,
        Keys: {
            Members: '/members',
            Me: '/me',
            Departments: '/departments',
            Gateways: '/gateways',
            Loggers: '/loggers',
            ByUser: '/byUser'
        }
    };
    Department = {
        Home: this._departmentsHome,
        AdminHome: this._adminDepartmentsHome,
        Keys: {
            Roles: '/roles',
            Role: '/role',
            Settings: '/settings',
            Users: '/users',
            Key: '/key',
            Issues: '/issues',
            Invite: '/invite',
            Invitations: '/invitations',
            Accept: '/accept',
            Decline: '/decline',
            Members: '/members',
            Enable: '/enable',
            Disable: '/disable',
            Thermomap: '/thermomap',
            Image: '/image',
            Tags: '/tags',
            AssetDevices: '/assets/devices',
            AcceptanceProtocols: '/acceptanceProtocols',
            Reject: '/reject',
            Return: '/return',
            ContactInfo: '/contact-info',
            Photo: '/photo'
        }
    };
    AcceptanceProtocols = {
        AdminHome: this._adminAcceptanceProtocolsHome
    };
    EventTypes = {
        Home: this._eventTypesHome,
        Units: this._eventTypesHome + '/units'
    };
    Notifications = {
        Home: this._notificationsHome,
        AdminHome: this._adminNotificationsHome,
        Subscriptions: this._notificationsHome + '/subscribe',
        Types: this._notificationsHome + '/metadata/types',
        AdminTypes: this._adminNotificationsHome + '/metadata/types',
        Priorities: this._notificationsHome + '/metadata/priorities',
        Channels: this._notificationsHome + '/metadata/channels',
        Send: this._adminNotificationsHome + '/send',
        Keys: {
            Remove: '/remove',
            RemoveAll: '/remove/all'
        }
    };
    NotificationSubscriptions = {
        Settings: '/settings',
        Notifications: '/notifications',
        Presets: '/presets',
        Schedules: '/schedules',
        Mode: '/schedules/mode'
    };
    EventValidation = {
        Validation: '/data/validation',
        Settings: '/settings',
        Triggers: '/triggers',
        Keys: { Mode: '/mode', Test: '/test', Pause: '/pause', All: '/all' }
    };
    Statistics = {
        Home: this._statisticsHome,
        Boundaries: this._statisticsHome + '/boundaries'
    };
    Issues = {
        Keys: {
            Issues: '/issues',
            Notifications: '/notifications',
            Acknowledge: '/acknowledge',
            Active: '/active'
        }
    };
    Reports = {
        Home: this._reportsHome,
        ExportPdf: '/reports/export/pdf',
        ExportRawPdf: '/reports/export/pdf/type-raw',
        Records: '/reports/records',
        Statistics: '/reports/records/statistics',
        Annotations: '/reports/records/annotations',
        ExportCsv: '/reports/export/csv',
        ExportRawCsv: '/reports/export/csv/type-raw',
        ExportFullCsv: '/reports/export/csv/type-full',
        ExportOnePagePdf: '/reports/export/pdf/type-one-page',
        ExportFullPdf: '/reports/export/pdf/type-full',
        ExportStatisticalPdf: '/reports/export/pdf/type-statistical',
        Configurations: '/reports/configurations',
        ActiveConfiguration: '/reports/configuration/active',
        StatusSocket: this._home_ws + '/reports/pdf/status',
        Keys: {
            File: '/file'
        }
    };
    Sources = {
        Keys: {
            Boundaries: '/boundaries',
            BoundariesPresets: '/boundaries/presets',
            Sources: '/sources',
            Groups: '/sources/groups',
            Exists: '/exists',
            Assign: '/assignments',
            Add: '/add',
            Remove: '/remove',
            All: '/all',
            Deleted: '/deleted',
            Revive: '/revive',
            FloorPlan: '/sources/floorPlan',
            Image: '/image',
            Thumbnail: '/thumbnail',
            Data: '/data',
            Quantities: '/quantities',
            Service: '/service',
            ServiceConfig: '/service/config',
            ServiceConfigs: '/service/configs',
            Stop: '/stop'
        }
    };
    CompanyLogger = {
        Home: this._companyLoggerHome,
        AdminHome: this._adminCompanyLoggersHome,
        Settings: this._companyLoggerHome + '/settings',
        Activate: this._companyLoggerHome + '/activate',
        Validate: this._adminCompanyLoggersHome + '/validate',
        Exists: this._adminCompanyLoggersHome + '/exists',
        EventTypes: this._adminCompanyLoggersHome + '/eventTypes',
        Keys: {
            Unpublish: '/unpublish',
            Protocol: '/calibration/protocol',
            ProtocolCopy: '/calibration/copy',
            Loggers: '/loggers',
            Activate: '/activate',
            Deactivate: '/deactivate',
            Calibration: '/calibration',
            Expiration: '/calibration/setExpiration',
            Revert: '/revert',
            Return: '/return',
            ReadData: '/readData',
            Data: '/data',
            Verify: '/verify',
            AllowedTypes: '/eventTypes/allowed',
            ComputedAllowedTypes: '/eventTypes/computed',
            Signal: '/signal',
            Notes: '/notes',
            Photo: '/photo'
        }
    };
    LoggerScan = {
        Home: this._home_ws + '/loggers/scan'
    };
    LoggerRegistration = {
        Home: this._home_ws + '/admin/loggers/registration',
        Manufacture: this._home_ws + '/admin/manufacturing'
    };
    SignalStrength = {
        Home: this._home_ws + '/gateways/signal',
        Logger: this._home_ws + '/loggers/signal'
    };
    PublicDashboard = {
        Home: this._publicDashboardHome,
        Keys: {
            Sources: '/sources',
            Siren: '/notifications/siren',
            Chart: '/sources/graph',
            Reports: '/sources/reports',
            EventTypes: '/eventTypes',
            Outage: '/sources/outage',
            ExportPdf: '/reports/pdf',
            ExportOnePagePdf: '/reports/one-page-report',
            ExportRawPdf: '/reports/raw-data-pdf',
            ExportStatisticalPdf: '/reports/pdf/type-statistical'
        }
    };
    Dashboard = {
        Keys: {
            Dashboards: '/data/dashboards',
            Pdf: '/pdf',
            Labels: '/labels/pdf'
        }
    };
    Tiers = {
        Home: this._departmentsHome,
        AdminHome: this._adminTiersHome,
        Keys: {
            Tiers: '/tiers',
            Active: '/tiers/active',
            Usage: '/tiers/usage',
            Request: '/tiers/request',
            Activate: '/activate',
            Deactivate: '/deactivate'
        }
    };
    Sales = {
        Home: this._salesHome,
        Feedback: this._salesHome + '/feedback',
        ReleaseNotes: this._salesHome + '/releaseNotes'
    };
    Queries = {
        Sources: 'sourceIds',
        Time: {
            From: 'from',
            To: 'to'
        },
        Page: 'page',
        PageSize: 'pageSize',
        Sorts: 'sorts',
        Annotations: 'annotations',
        Name: 'name',
        CompanyLoggerId: 'companyLoggerId',
        CompanyId: 'companyId',
        DepartmentId: 'departmentId',
        SerialNumber: 'serialNumber',
        From: 'from',
        To: 'to',
        Duration: 'duration',
        Token: 'token',
        DeviceId: 'deviceId',
        CalibrationExpiresBefore: 'ExpiresBefore',
        Tz: 'tz',
        Since: 'since',
        AlarmOnly: 'alarmOnly',
        ShowEmpty: 'showEmpty',
        ShowChart: 'showChart',
        ShowAnnotationTable: 'showAnnotationTable',
        ShowRecordsTable: 'showRecordsTable',
        StartBefore: 'startBefore',
        StartAfter: 'startAfter',
        EndBefore: 'endBefore',
        EndAfter: 'endAfter',
        IncludeSystemNotifications: 'includeSystemNotifications',
        Filters: 'Filters',
        SourcesArray: 'sourceIds[]',
        Note: 'note',
        Model: 'model',
        Interval: 'interval',
        Offset: 'offset',
        SourceId: 'sourceId',
        All: 'all',
        Timezone: 'timezone',
        ScheduleId: 'scheduleId',
        CalibrationId: 'calibrationId',
        LatStart: 'latStart',
        LatEnd: 'latEnd',
        LongStart: 'longStart',
        LongEnd: 'longEnd'
    };
    DeviceDebug = {
        Home: this._home_ws + '/admin/devices/monitor'
    };
    AdminSales = {
        Home: this._adminSalesHome,
        Analytics: this._adminSalesHome + '/analytics',
        MailingList: '/mailingList',
        Feedback: this._adminSalesHome + '/feedback',
        ReleaseNotes: this._adminSalesHome + '/releaseNotes'
    };
    AdminTiers = {
        Home: this._adminTiersHome,
        AllFeatures: this._adminTiersHome + '/allFeatures',
        Requests: this._adminTiersHome + '/requests',
        Company: {
            Home: this._adminCompanyTiersHome,
            Keys: {
                Tiers: '/tiers',
                Active: '/tiers/active',
                Activate: '/activate',
                Deactivate: '/deactivate'
            }
        }
    };
    AdminSystem = {
        Home: this._adminSystemHome,
        Settings: this._adminSystemHome + '/settings',
        Tasks: this._adminSystemHome + '/tasks',
        Keys: {
            Running: '/running',
            Jobs: 'execute/jobs',
            Execute: 'execute'
        }
    };
    AdminDevices = {
        AdminHome: this._adminDevicesHome,
        ProductNumbers: this._adminDevicesHome + '/productNumbers',
        Keys: {
            Import: '/import'
        }
    };
    constructor() { }
}
export default new ApiLinks();
